module.exports = __webpack_public_path__ + "static/media/it-support-img-5.1681efce.jpg";